import React, { useEffect, useState } from 'react';
import { Clock, Flame } from 'lucide-react';
import { motion } from 'framer-motion';
export function UrgencyBlock() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 10
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="bg-white py-5 md:py-8 px-4 text-center border-b border-gray-100" data-id="element-399">
      <div className="max-w-2xl mx-auto" data-id="element-400">
        <div className="flex items-center justify-center gap-1.5 md:gap-2 text-accent-600 font-bold mb-3 md:mb-4 text-sm md:text-base" data-id="element-401">
          <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-402" />
          <span data-id="element-403">El precio de lanzamiento termina en:</span>
        </div>

        <div className="flex items-center justify-center gap-1.5 md:gap-4 mb-4" data-id="element-404">
          <div className="bg-gray-900 text-white rounded-lg px-3 py-2 md:px-4 md:py-3 min-w-[60px] md:min-w-[80px]" data-id="element-405">
            <span className="text-2xl md:text-4xl font-black font-mono" data-id="element-406">
              {formatTime(timeLeft.hours)}
            </span>
            <span className="block text-[9px] md:text-[10px] uppercase tracking-widest mt-0.5 md:mt-1 text-gray-400" data-id="element-407">
              Horas
            </span>
          </div>
          <span className="text-xl md:text-2xl font-bold text-gray-400" data-id="element-408">:</span>
          <div className="bg-gray-900 text-white rounded-lg px-3 py-2 md:px-4 md:py-3 min-w-[60px] md:min-w-[80px]" data-id="element-409">
            <span className="text-2xl md:text-4xl font-black font-mono" data-id="element-410">
              {formatTime(timeLeft.minutes)}
            </span>
            <span className="block text-[9px] md:text-[10px] uppercase tracking-widest mt-0.5 md:mt-1 text-gray-400" data-id="element-411">
              Min
            </span>
          </div>
          <span className="text-xl md:text-2xl font-bold text-gray-400" data-id="element-412">:</span>
          <div className="bg-gray-900 text-white rounded-lg px-3 py-2 md:px-4 md:py-3 min-w-[60px] md:min-w-[80px]" data-id="element-413">
            <motion.span key={timeLeft.seconds} initial={{
            scale: 1.2,
            color: '#fca5a5'
          }} animate={{
            scale: 1,
            color: '#f87171'
          }} className="inline-block text-2xl md:text-4xl font-black font-mono text-accent-400" data-id="element-414">
              {formatTime(timeLeft.seconds)}
            </motion.span>
            <span className="block text-[9px] md:text-[10px] uppercase tracking-widest mt-0.5 md:mt-1 text-gray-400" data-id="element-415">
              Seg
            </span>
          </div>
        </div>

        <p className="text-gray-600 font-medium mb-4 md:mb-6 text-xs md:text-sm" data-id="element-416">
          Después sube{' '}
          <span className="font-bold text-gray-900" data-id="element-417">$8.000 ARS</span> y no
          vuelve a bajar.
        </p>

        <div className="bg-gray-100 rounded-full h-3 md:h-4 max-w-md mx-auto overflow-hidden relative" data-id="element-418">
          <div className="absolute top-0 left-0 h-full bg-accent-500 w-[68%] rounded-full relative overflow-hidden" data-id="element-419">
            <div className="absolute inset-0 bg-white/20 w-full h-full animate-[shimmer_2s_infinite] -skew-x-12 translate-x-[-100%]" data-id="element-420"></div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-1 mt-1.5 md:mt-2 text-[11px] md:text-sm font-bold text-accent-600" data-id="element-421">
          <Flame className="w-3 h-3 md:w-4 md:h-4" data-id="element-422" />
          Cupos promocionales — 68% tomados
        </div>
      </div>
      <style data-id="element-423">{`
        @keyframes shimmer { 100% { transform: translateX(200%) skewX(-12deg); } }
      `}</style>
    </div>;
}